<script lang="ts">
    import cn from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    let className = "";
    export { className as class };
    export let onClick: (value: string) => void;
    export let openedTab: string | null;
    export let tab: { value: string; name: string };
    export let variant: "squared" | "rounded";
</script>

<li
    class={cn("gw-tab", className, {
        [`gw-tab--${variant}`]: variant,
    })}
>
    <BaseButton
        value={tab.value}
        class={cn("gw-tab-btn", {
            "gw-tab-btn--opened": tab.value === openedTab,
            [`gw-tab-btn--${variant}`]: variant,
        })}
        on:click={() => onClick(tab.value)}
    >
        {tab.name}
    </BaseButton>
</li>

<style lang="postcss" global>
    .gw-tab {
        font-size: 16px;

        &--squared {
            height: 54px;
            &:not(:last-child) {
                margin-right: -1px;
            }
        }
        &--rounded {
            height: 48px;
            &:not(:last-child) {
                margin-right: 14px;
            }
        }
    }

    :global(.gw-btn.gw-tab-btn) {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--gw-tab-font-family, "Noto Sans TC", sans-serif);
        font-size: inherit;
        text-transform: uppercase;
        transition: all 0.3s ease;
    }

    :global(.gw-btn.gw-tab-btn--squared) {
        height: 100%;
        width: 100%;
        border: 1px solid #666;
        color: #666;
        font-weight: 400;
        text-align: center;
        cursor: pointer;
    }

    :global(.gw-btn.gw-tab-btn--rounded) {
        padding: 14px 30px;
        background-color: var(--gw-tab-rounded-bg-color, #f0f0f0);
        border-radius: 30px;
        border: 1px solid transparent;
        color: #3c3c3c;
        font-weight: 500;
        white-space: nowrap;
    }

    :global(.gw-btn.gw-tab-btn.gw-tab-btn--opened) {
        background-color: #3c3c3c;
        color: #ffffff;
    }

    :global(.gw-btn.gw-tab-btn:hover) {
        background-color: #3c3c3c;
        color: #ffffff;
    }

    @media all and (max-width: 600px) {
        .gw-tab {
            &--squared {
                height: 44px;
                font-size: 14px;
            }
            &--rounded {
                height: 36px;
                font-size: 12px;
                &:not(:last-child) {
                    margin-right: 6px;
                }
            }
        }

        :global(.gw-btn.gw-tab-btn--rounded) {
            padding: 14px 20px;
        }
    }
</style>
